import { dimensionsListSelectorKeyValue } from '@store/common/dimensionList/selectors';
import { useAtom } from 'jotai';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

// TODO: remove this in next release and add the search filter to the useFetchActiveOutliers.ts
export function useSearch({ data, columnKey, searchTextAtom, searchFn }) {
  const [searchText, setSearchText] = useAtom(searchTextAtom);
  const dimensionList = useSelector(dimensionsListSelectorKeyValue); //TODO: This is not generalized, remove this functionality to useFetchActiveOutliers.ts

  const filteredRows = useMemo(() => {
    if (searchText) {
      return searchFn({ searchText, dimensionList, data, columnKey });
    }
    return data;
  }, [data, searchText, searchFn, columnKey]);

  return { filteredRows, searchText, onSearch: setSearchText };
}
